import { tracked } from '@glimmer/tracking';

import type { APIData } from 'webapp-types';

import MetricLimitationBase from 'webapp/models-custom/metric-limitation/base';

// for more general info check MetricLimitationBase

export default class MetricLimitationCumulative extends MetricLimitationBase<APIData.Metrics.GranulationVariations> {
	@tracked override isParentDisabled = false;

	unsupportedBaseConstraint = false;

	get disabled(): boolean {
		let disabled = false;

		if (this.isParentDisabled) {
			disabled = true;
		} else if (this.rawData) {
			// set as disabled if neither of cumulatives are available
			disabled = !this.allowCumulative && !this.allowSeparate;
		}

		return disabled;
	}

	get onlyOneOptionAvailable(): boolean {
		return (
			(this.allowCumulative && !this.allowSeparate) ||
			(!this.allowCumulative && this.allowSeparate)
		);
	}

	get allowCumulative(): boolean {
		return !this.rawData?.cumulative?.disabled;
	}

	get allowSeparate(): boolean {
		return !this.rawData?.separate?.disabled;
	}

	get infoText(): string {
		const info: string[] = [];

		if (this.rawData) {
			if (this.rawData.cumulative?.info?.message) {
				info.push(this.rawData.cumulative.info.message);
			}
			if (this.rawData.separate?.info?.message) {
				info.push(this.rawData.separate.info.message);
			}
		} else if (this.isParentDisabled) {
			info.push('Granulation not available');
		}

		return info.join('<br>');
	}
}
